<template>
  <div :class="`field-wrapper field-wrapper-edit ${textAlign} ${classes}`">
    <el-input
      class="field-input-amount"
      :size="size"
      :clearable="clearable && !visibleFormat"
      :disabled="disabled"
      :placeholder="placeholder"
      :maxlength="maxlength"
      v-model="selfValue"
      @focus="onInputFocus"
      @blur="onInputBlur"
      @keyup.native="onKeyup"
      @afterpaste.native="onAfterpaste"
      @change="onChange"
    >
      <template v-if="$slots.prepend" #prepend>
        <slot name="prepend" />
      </template>
      <template v-if="$slots.prefix" #prefix><slot name="prefix" /></template>

      <slot />

      <template v-if="$slots.append" #append><slot name="append" /></template>
      <template v-if="$slots.suffix" #suffix><slot name="suffix" /></template>
    </el-input>
    <div
      v-show="false && visibleFormat && formatChars.length > 0"
      class="field-input-format-box"
    >
      <i
        v-for="(item, _index) in formatChars"
        :key="_index"
        :class="formatCharClass(item)"
      >
        {{ item }}
      </i>
    </div>
  </div>
</template>

<script>
// import _ from "lodash"
import math from "@libs/js/mathjs";
import { useFormatAmount } from "@libs/js/formatAmount";

const { validAmount, isReservedSymbol, inputNumberFilter, formatAmount } =
  useFormatAmount();

export default {
  name: "inputAmount",
  props: {
    value: { type: [Number, String], default: undefined },
    classes: { type: String, default: "" },
    textAlign: { type: String, default: "right" },
    size: { type: String, default: "default" },
    label: { type: String, default: "" },
    prop: { type: String, default: "" },
    rules: { type: Object, default: undefined },
    placeholder: { type: String, default: "请填写" },
    // 最大输入长度
    // 默认长度16，如：9,999,999,999,999.99
    maxlength: { type: Number, default: 16 },
    tooltip: { type: String, default: undefined },
    clearable: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    // 数值类型
    // "int" | "+int" | "-int" | "+number" | "-number" | undefined
    type: { type: String, default: undefined },
    // 小数点后位数
    fractionLength: { type: Number, default: 2 },
    // 默认空值
    emptyValue: { type: [Number, String, null], default: undefined },
  },
  // emits: ["input", "change"],

  data() {
    return {
      visibleFormat: true,
    };
  },
  computed: {
    selfValue: {
      get() {
        return this.invalidValue(this.value);
      },
      set(newValue) {
        // console.log("selfValue:", newValue, this.invalidValue(newValue))
        this.$emit("input", this.invalidValue(newValue));
      },
    },
    formatStr() {
      if (this.visibleFormat === true) {
        return formatAmount(this.selfValue, this.type);
      }
      return "";
    },
    formatChars() {
      return this.formatStr ? [...this.formatStr] : [];
    },
  },
  methods: {
    onKeyup(evt) {
      this.selfValue = evt.target.value = inputNumberFilter(
        evt.target.value,
        this.type
      );
    },
    onAfterpaste(evt) {
      this.selfValue = evt.target.value = inputNumberFilter(
        evt.target.value,
        this.type
      );
    },

    // 数值有效性验证
    invalidValue(val) {
      if (isReservedSymbol(val)) {
        return val;
      }
      if (validAmount(val)) {
        return val;
      }
      return "";
    },

    formatCharClass(item /* , itemIndex */) {
      switch (item) {
        case ",":
          // return "blue"
          return "";
        case "￥":
        case "¥":
          // return "symbol"
          return "";
        case ".":
          return "";
        case "-":
          // return "dot"
          return "";
        default:
          return "";
      }
    },

    onInputFocus() {
      this.visibleFormat = false;
    },
    onInputBlur() {
      this.visibleFormat = true;
      this.$emit("input", this.selfValue);
    },
    onChange(val) {
      if (isReservedSymbol(val)) {
        // 操作中间状态，未完成有效输入
        this.selfValue = val = 0;
      }

      // console.log(val, math.format(val, { notation: "fixed", precision: this.fractionLength, isBankToFixed: true}))
      if (val === 0 && this.emptyValue !== undefined) {
        this.selfValue = val = this.emptyValue;
      } else {
        // 矫正保留两位小数
        this.selfValue = val = math.format(math.bignumber(val), {
          notation: "fixed",
          precision: this.fractionLength,
          isBankToFixed: true,
        });
      }
      this.$emit("change", val);
    },
  },
};
</script>

<style lang="less" scoped>
@color-primary: #3078ff;
@color-white: #fff;
@danger-color: #ff5d5d;
@table-color: #606266;
@table-bg-color: #f5f7fa; //#f2f6ff;
@amount-color: #333;
@amount-font-size: 15px;
@amount-font-family: "DIN", "DIN-Bold";

.field-wrapper {
  //
}

.field-input-amount {
  /deep/ .el-input__inner {
    text-align: right;
    color: @amount-color;
    // 商户端统一字体样式，不使用DIN作为金额字体
    // font-family: @amount-font-family;
    font-size: @amount-font-size;
  }
  &.el-input--small,
  &.el-input--mini {
    /deep/ .el-input__inner {
      font-size: 14px;
    }
  }
  .icon-suffix-edit {
    color: @color-primary;
  }
}
.field-input-format-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 0 10px;
  // text-align: right;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: @amount-color;
  font-size: @amount-font-size;
  // 商户端统一字体样式，不使用DIN作为金额字体
  // font-family: @amount-font-family;
  // color: #fff;
  // background: rgba(20, 0, 0, 1);
  background: @color-white;
  overflow: hidden;
  pointer-events: none;
  i {
    font-style: normal;
    display: inline-block;
    &.symbol {
      margin-right: 3px;
      color: #f2f2f2;
    }
    &.grey {
      color: #999;
    }
    &.dot {
      margin: 0 2px;
      color: @danger-color;
      scale: 1.2;
    }
    &.black {
      color: #333;
    }
    &.blue {
      color: #a1c3ff;
    }
  }
  .suffix {
    display: inline-block;
    & > :first-child {
      margin-left: 6px;
    }
    .icon-suffix-edit {
      color: @color-primary;
    }
  }
}
.is-disabled + .field-input-format-box {
  background-color: @table-bg-color;
  .suffix {
    display: none;
  }
}
.sys-cell.is-error {
  .field-input-format-box {
    box-shadow: 0 0 0 1px var(--el-color-danger) inset;
    .el-form-item__error {
      top: auto;
      bottom: 100%;
    }
  }
}

.field-wrapper.field-wrapper-edit {
  position: relative;
  // .field-input-amount {
  //   &.is-disabled {
  //     :deep(.el-input__wrapper) {
  //       box-shadow: 0 0 0 1px var(--el-disabled-border-color) inset;
  //     }
  //   }
  // }
  .field-input-format-box {
    top: 2px;
    left: 2px;
    right: 2px;
    bottom: 2px;
    // line-height: 28px;
  }
  &.sys-cell.is-error {
    .field-input-format-box {
      box-shadow: none;
    }
  }
}

.left {
  .field-input-amount {
    :deep(.el-input__inner) {
      text-align: left;
    }
  }
  .field-input-format-box {
    justify-content: flex-start;
  }
}
.right {
  .field-input-amount {
    :deep(.el-input__inner) {
      text-align: right;
    }
  }
  .field-input-format-box {
    justify-content: flex-end;
  }
}
</style>
